import { Nota } from '../ui/primitivos.jsx';

/**
 * O aviso dos modais que recebem dinheiro quando não há caixa aberto (ou a data
 * do recebimento é anterior à abertura do caixa: também cai fora dele). Não
 * bloqueia nada: o recebimento acontece e o valor vai para "dinheiro fora do
 * caixa" (`/caixa`), onde a recepção o confere depois. Quem decide se o
 * aviso aparece é `avisoDeDinheiroForaDoCaixa` (função pura, testada).
 */
export function AvisoDeCaixa() {
  return (
    <Nota>
      <b>Sem caixa aberto — ou com data anterior à abertura do caixa — o dinheiro fica fora do
      caixa.</b>{' '}
      Ele será registrado normalmente, como <b>dinheiro fora do caixa</b>, e não entra na
      conferência da gaveta. Abra o caixa em <i>Caixa da recepção</i> para que as próximas
      entradas contem.
    </Nota>
  );
}
